export default {
  loading: 0,
  modules: [],
  progress: {
    module: 1,
    level: 1,
  },
  currentLevelId: null,
  currentModuleId: null,
};
